import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "CI 구성하기",
  "description": "Turborepo가 필요한 모든 task를 효율적으로 완료하고 개발 워크플로우를 가속화하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 Continuous Integration 파이프라인에서 수행해야 하는 빌드, 린트, 테스트 및 기타 모든 task를 가속화합니다. 병렬화와 Remote Caching을 통해 Turborepo는 CI를 극적으로 빠르게 만듭니다."
  }, {
    "heading": "",
    "content": "CI 벤더를 Remote Cache에 연결하고 task를 실행하는 방법의 예제는 CI 가이드를 참조하세요."
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "CI에 대해 Remote Caching을 활성화하려면 Turborepo가 Remote Cache에 액세스할 수 있도록 환경 변수를 설정합니다."
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "환경 변수"
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "설명"
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "TURBO_TOKEN"
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "Remote Cache에 액세스하기 위한 Bearer 토큰"
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "TURBO_TEAM"
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "리포지토리와 연결된 계정 이름. Vercel Remote Cache를 사용하는 경우 팀의 slug입니다."
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "turbo를 통해 task를 실행하면 CI가 캐시를 적중하여 파이프라인을 가속화할 수 있습니다."
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "Vercel의 내장 CI/CD는 설정 없이 관리되는 Vercel Remote Cache에 자동으로 연결됩니다. 다른 CI 벤더를 Vercel Remote Cache에 연결하기 위한 토큰을 가져오려면 Vercel Remote Cache 문서를 참조하세요."
  }, {
    "heading": "remote-caching-활성화하기",
    "content": "자체 호스팅 Remote Cache 옵션은 Turborepo의 Remote Cache 문서를 참조하세요."
  }, {
    "heading": "ci에서-task-실행하기",
    "content": "개발 및 CI 머신에 turbo를 전역으로 설치하면 개발부터 배포까지 전체 리포지토리를 실행하는 데 하나의 멘탈 모델을 사용할 수 있습니다. turbo.json에 등록한 task는 CI에서 정확히 동일하게 작동합니다."
  }, {
    "heading": "ci에서-task-실행하기",
    "content": "task 설정 방법에 대한 자세한 내용은 Task 구성하기 페이지를 참조하세요."
  }, {
    "heading": "ci에서-task-실행하기",
    "content": "CI에서 task를 실행하는 예제는 CI 가이드를 참조하세요."
  }, {
    "heading": "진입점-필터링하기",
    "content": "로컬에서 turbo로 작업할 때와 정확히 동일하게 --filter 플래그를 사용하여 task를 필터링할 수 있습니다. 패키지, 디렉토리 및 Git 기록별 필터링이 모두 CI에서 지원됩니다."
  }, {
    "heading": "진입점-필터링하기",
    "content": "소스 제어 변경 사항을 사용한 필터링은 머신에서 기록을 사용할 수 있는 경우에만\n가능합니다. shallow clone을 사용하는 경우 기록을 사용할 수 없습니다."
  }, {
    "heading": "진입점-필터링하기",
    "content": "또한 --affected 플래그를 사용하여 변경 사항이 있는 패키지의 task만 실행할 수 있습니다."
  }, {
    "heading": "docker",
    "content": "Docker는 많은 배포 파이프라인의 중요한 부분입니다. Turborepo의 prune 하위 명령은 이미지에서 불필요한 종속성과 코드를 제거하여 경량 이미지를 배포하는 데 도움이 됩니다."
  }, {
    "heading": "docker",
    "content": "Docker를 사용하여 Turborepo에서 배포하는 방법에 대한 자세한 내용은 전용 Docker 가이드를 참조하세요."
  }, {
    "heading": "영향을-받은-task만-실행하기",
    "content": "--affected 플래그를 사용하여 변경 사항이 있는 task만 실행할 수 있습니다."
  }, {
    "heading": "영향을-받은-task만-실행하기",
    "content": "다음과 같은 상황에서 이 플래그를 사용하려고 할 것입니다:"
  }, {
    "heading": "영향을-받은-task만-실행하기",
    "content": "monorepo의 패키지 전체에서 많은 task를 실행하고 있으며 코드 변경 사항이 있는 패키지의 task만 실행하려는 경우."
  }, {
    "heading": "영향을-받은-task만-실행하기",
    "content": "Remote Cache를 사용하지 않지만 CI에서 가능한 한 적은 작업을 수행하려는 경우."
  }, {
    "heading": "영향을-받은-task만-실행하기",
    "content": "Remote Cache를 사용하고 있으며 대규모 리포지토리에 있는 경우. 캐시에서 복원될 task의 양을 최소화하면 네트워크를 통해 전송할 데이터가 줄어들어 캐시 복원이 더 빨라집니다."
  }, {
    "heading": "영향을-받은-task만-실행하기",
    "content": "이미 고급 필터링 기술 또는 turbo-ignore를 사용하여 --affected와 동일하거나 유사한 동작을 생성하고 있는 경우. 이 새 플래그를 사용하여 스크립팅을 단순화할 기회가 있을 것입니다."
  }, {
    "heading": "영향을-받은-task만-실행하기",
    "content": "--affected는 모든 task를 실행하는 것으로 폴백하기 때문에 맞춤형 필터링보다 shallow clone을 더 우아하게 처리할 수 있습니다."
  }, {
    "heading": "github-actions에서---affected-사용하기",
    "content": "CI/CD 파이프라인은 --affected를 사용하기에 완벽한 곳입니다. --affected를 사용하면 Turborepo는 GITHUB_BASE_REF와 같이 GitHub에서 설정한 환경 변수를 검사하여 GitHub Actions에서 실행 중임을 자동으로 감지할 수 있습니다."
  }, {
    "heading": "github-actions에서---affected-사용하기",
    "content": "PR의 컨텍스트에서 이는 Turborepo가 PR의 기본 브랜치와 PR의 헤드 브랜치 간에 변경된 패키지를 결정할 수 있음을 의미합니다. 이를 통해 PR의 변경 사항에 영향을 받는 패키지에 대해서만 task를 실행할 수 있습니다."
  }, {
    "heading": "github-actions에서---affected-사용하기",
    "content": "GITHUB_BASE_REF는 pull_request 및 pull_request_target 이벤트에서 잘 작동하지만 일반 push 이벤트에서는 사용할 수 없습니다. 이러한 경우 GITHUB_EVENT_PATH를 사용하여 커밋과 비교할 기본 브랜치를 결정합니다. force push 및 추가 커밋이 없는 브랜치 푸시에서는 브랜치의 첫 번째 커밋의 부모와 비교합니다."
  }, {
    "heading": "turbo-ignore-사용하기",
    "content": "코드베이스와 CI가 성장함에 따라 더 빠르게 만드는 더 많은 방법을 찾기 시작할 수 있습니다. 캐시를 적중하는 것이 유용하지만 작업을 완전히 건너뛸 수도 있습니다. turbo-ignore를 사용하면 어쨌든 캐시 적중으로 끝날 종속성 설치와 같은 긴 컨테이너 준비 단계를 건너뛸 수 있습니다."
  }, {
    "heading": "리포지토리-체크아웃하기",
    "content": "리포지토리를 복제하는 것으로 시작합니다. 사용할 복제 깊이에 대한 기록이 있는 복제가 비교에 필요합니다."
  }, {
    "heading": "리포지토리-체크아웃하기",
    "content": "기본적으로 turbo-ignore는 부모 커밋을 사용합니다. 더 깊이를 사용자\n지정하려면 turbo-ignore 참조를 참조하세요."
  }, {
    "heading": "패키지-및-task에-대해-turbo-ignore-실행하기",
    "content": "기본적으로 turbo-ignore는 현재 작업 디렉토리의 build task를 사용합니다."
  }, {
    "heading": "패키지-및-task에-대해-turbo-ignore-실행하기",
    "content": "다른 task의 변경 사항을 확인하려면 --task 플래그를 사용합니다."
  }, {
    "heading": "패키지-및-task에-대해-turbo-ignore-실행하기",
    "content": "특정 패키지 및 해당 종속성의 변경 사항을 확인하려면 패키지 이름을 인수로 추가합니다."
  }, {
    "heading": "패키지-및-task에-대해-turbo-ignore-실행하기",
    "content": "web 패키지를 인수로 추가하여 web 패키지 및 해당 종속성에 대한 build task의 변경 사항을 확인합니다:"
  }, {
    "heading": "패키지-및-task에-대해-turbo-ignore-실행하기",
    "content": "자동 패키지 범위 지정을 사용하여 web 패키지 및 해당 종속성에 대한 build task의 변경 사항을 확인합니다:"
  }, {
    "heading": "패키지-및-task에-대해-turbo-ignore-실행하기",
    "content": "자동 패키지 범위 지정 및 --task 플래그를 사용하여 docs 패키지 및 해당 종속성에 대한 test task의 변경 사항을 확인합니다:"
  }, {
    "heading": "결과-처리하기",
    "content": "패키지 또는 해당 내부 종속성에서 변경 사항이 감지되면 turbo는 1 상태 코드로 종료됩니다. 변경 사항이 감지되지 않으면 0으로 종료됩니다."
  }, {
    "heading": "결과-처리하기",
    "content": "이 상태 코드를 사용하여 CI 파이프라인의 나머지 부분이 수행해야 할 작업을 선택할 수 있습니다. 예를 들어, 1 종료 코드는 종속성을 설치하고 task를 실행하는 것으로 진행해야 함을 의미할 것입니다."
  }, {
    "heading": "결과-처리하기",
    "content": "더 고급 사용 사례는 turbo-ignore 참조를 참조하세요."
  }, {
    "heading": "캐싱에-의존하기",
    "content": "Turborepo의 캐싱 기능을 사용하면 최소한의 복잡성으로 빠른 CI 파이프라인을 생성할 수 있습니다. Remote Caching 및 --filter 플래그를 사용하여 빌드할 패키지를 대상으로 지정하면 Turborepo는 오버헤드가 거의 없이 대규모 monorepo에 대한 변경 감지를 처리합니다."
  }, {
    "heading": "캐싱에-의존하기",
    "content": "예를 들어, CI는 다음 두 명령을 실행하여 품질 검사를 빠르게 처리하고 대상 애플리케이션을 빌드할 수 있습니다:"
  }, {
    "heading": "캐싱에-의존하기",
    "content": "turbo run lint check-types test: 전체 리포지토리에 대한 품질 검사를 실행합니다. 변경되지 않은 패키지는 캐시를 적중합니다."
  }, {
    "heading": "캐싱에-의존하기",
    "content": "turbo build --filter=web: turbo.json에 등록한 build task를 사용하여 web 패키지를 빌드합니다. web 패키지 또는 해당 종속성이 변경되지 않은 경우 빌드도 캐시를 적중합니다."
  }, {
    "heading": "캐싱에-의존하기",
    "content": "코드베이스가 확장됨에 따라 CI를 최적화할 더 구체적인 기회를 찾을 수 있지만 캐싱에 의존하는 것이 시작하기에 좋은 곳입니다."
  }, {
    "heading": "ci에서-전역-turbo",
    "content": "전역 turbo를 사용하면 CI 워크플로우에서 편리하며 CI에 특정한 명령을 쉽게 실행하고 자동 Workspace 범위 지정을 활용할 수 있습니다."
  }, {
    "heading": "ci에서-전역-turbo",
    "content": "그러나 일부 경우에는 패키지 관리자로 패키지를 설치하기 전에 turbo 명령 또는 turbo를 사용하는 스크립트를 실행할 수 있습니다. 이에 대한 한 가지 예는 turbo prune을 사용하여 Docker 이미지를 생성하는 것입니다. 이 상황에서 전역 turbo는 해당 버전의 바이너리가 아직 설치되지 않았기 때문에 package.json의 버전을 사용할 수 없습니다."
  }, {
    "heading": "ci에서-전역-turbo",
    "content": "이러한 이유로 주요 버전 내에서 중단 변경이 도입되지 않으므로 CI에서 turbo의 전역 설치를 package.json의 주요 버전에 고정하는 것을 권장합니다. 또한 정확한 버전을 고정하여 안정성을 추가로 선택할 수 있지만 패치 릴리스에서 버그 수정을 받기 위해 유지 관리 부담을 감수해야 합니다."
  }, {
    "heading": "ci에서-turbo-run-사용하기",
    "content": "turbo run은 Turborepo에서 작업할 때 가장 일반적으로 사용하는 명령이므로 편의를 위해 turbo로 별칭이 지정됩니다. 이는 로컬에서 작업하기에 좋지만 turbo prune 및 turbo generate와 같은 turbo에 대한 다른 하위 명령이 있습니다."
  }, {
    "heading": "ci에서-turbo-run-사용하기",
    "content": "우리는 항상 turbo를 개선하기 위해 노력하고 있으므로 향후 더 많은 하위 명령을 추가할 수 있습니다. 이러한 이유로 CI에서 turbo run을 사용하여 이름 충돌을 방지할 수 있습니다."
  }, {
    "heading": "ci에서-turbo-run-사용하기",
    "content": "예를 들어, CI 파이프라인에 turbo deploy 명령이 있는 경우 turbo CLI에 직접 빌드된 잠재적인 deploy 하위 명령과 충돌할 수 있습니다. 이를 피하려면 CI 파이프라인에서 대신 turbo run deploy를 사용하세요."
  }, {
    "heading": "캐시-적중으로-인한-빌드-손상",
    "content": "task가 캐시를 미스할 때 통과하지만 캐시를 적중할 때 실패하는 경우, task에 대한 outputs 키를 올바르게 구성하지 않았을 가능성이 높습니다."
  }, {
    "heading": "잘못된-환경-변수를-사용한-배포",
    "content": "task에 대해 env 또는 globalEnv 키를 정의하지 않은 경우 Turborepo는 해시를 생성할 때 이를 사용할 수 없습니다. 이는 다른 환경에 있음에도 불구하고 task가 캐시를 적중할 수 있음을 의미합니다."
  }, {
    "heading": "잘못된-환경-변수를-사용한-배포",
    "content": "env 및 globalEnv 키에 대한 구성을 확인하세요."
  }, {
    "heading": "다음-단계",
    "content": "이제 Turborepo로 애플리케이션을 배포하는 데 필요한 모든 것이 있습니다. 특정 사용 사례에 대해 자세히 알아보려면 가이드 확인 또는 핵심 개념 자세히 알아보기를 참조하세요."
  }],
  "headings": [{
    "id": "remote-caching-활성화하기",
    "content": "Remote Caching 활성화하기"
  }, {
    "id": "ci에서-task-실행하기",
    "content": "CI에서 task 실행하기"
  }, {
    "id": "진입점-필터링하기",
    "content": "진입점 필터링하기"
  }, {
    "id": "docker",
    "content": "Docker"
  }, {
    "id": "task-및-기타-불필요한-작업-건너뛰기",
    "content": "Task 및 기타 불필요한 작업 건너뛰기"
  }, {
    "id": "영향을-받은-task만-실행하기",
    "content": "영향을 받은 task만 실행하기"
  }, {
    "id": "github-actions에서---affected-사용하기",
    "content": "GitHub Actions에서 --affected 사용하기"
  }, {
    "id": "turbo-ignore-사용하기",
    "content": "turbo-ignore 사용하기"
  }, {
    "id": "리포지토리-체크아웃하기",
    "content": "리포지토리 체크아웃하기"
  }, {
    "id": "패키지-및-task에-대해-turbo-ignore-실행하기",
    "content": "패키지 및 task에 대해 turbo-ignore 실행하기"
  }, {
    "id": "결과-처리하기",
    "content": "결과 처리하기"
  }, {
    "id": "모범-사례",
    "content": "모범 사례"
  }, {
    "id": "캐싱에-의존하기",
    "content": "캐싱에 의존하기"
  }, {
    "id": "ci에서-전역-turbo",
    "content": "CI에서 전역 turbo"
  }, {
    "id": "ci에서-turbo-run-사용하기",
    "content": "CI에서 turbo run 사용하기"
  }, {
    "id": "문제-해결",
    "content": "문제 해결"
  }, {
    "id": "캐시-적중으로-인한-빌드-손상",
    "content": "캐시 적중으로 인한 빌드 손상"
  }, {
    "id": "잘못된-환경-변수를-사용한-배포",
    "content": "잘못된 환경 변수를 사용한 배포"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from '#components/tabs';
import {Step, Steps} from '#components/steps';
export const toc = [{
  depth: 2,
  url: "#remote-caching-활성화하기",
  title: _jsx(_Fragment, {
    children: "Remote Caching 활성화하기"
  })
}, {
  depth: 2,
  url: "#ci에서-task-실행하기",
  title: _jsx(_Fragment, {
    children: "CI에서 task 실행하기"
  })
}, {
  depth: 3,
  url: "#진입점-필터링하기",
  title: _jsx(_Fragment, {
    children: "진입점 필터링하기"
  })
}, {
  depth: 2,
  url: "#docker",
  title: _jsx(_Fragment, {
    children: "Docker"
  })
}, {
  depth: 2,
  url: "#task-및-기타-불필요한-작업-건너뛰기",
  title: _jsx(_Fragment, {
    children: "Task 및 기타 불필요한 작업 건너뛰기"
  })
}, {
  depth: 3,
  url: "#영향을-받은-task만-실행하기",
  title: _jsx(_Fragment, {
    children: "영향을 받은 task만 실행하기"
  })
}, {
  depth: 4,
  url: "#github-actions에서---affected-사용하기",
  title: _jsxs(_Fragment, {
    children: ["GitHub Actions에서 ", _jsx("code", {
      children: "--affected"
    }), " 사용하기"]
  })
}, {
  depth: 3,
  url: "#turbo-ignore-사용하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo-ignore"
    }), " 사용하기"]
  })
}, {
  depth: 3,
  url: "#리포지토리-체크아웃하기",
  title: _jsx(_Fragment, {
    children: "리포지토리 체크아웃하기"
  })
}, {
  depth: 3,
  url: "#패키지-및-task에-대해-turbo-ignore-실행하기",
  title: _jsxs(_Fragment, {
    children: ["패키지 및 task에 대해 ", _jsx("code", {
      children: "turbo-ignore"
    }), " 실행하기"]
  })
}, {
  depth: 3,
  url: "#결과-처리하기",
  title: _jsx(_Fragment, {
    children: "결과 처리하기"
  })
}, {
  depth: 2,
  url: "#모범-사례",
  title: _jsx(_Fragment, {
    children: "모범 사례"
  })
}, {
  depth: 3,
  url: "#캐싱에-의존하기",
  title: _jsx(_Fragment, {
    children: "캐싱에 의존하기"
  })
}, {
  depth: 3,
  url: "#ci에서-전역-turbo",
  title: _jsxs(_Fragment, {
    children: ["CI에서 전역 ", _jsx("code", {
      children: "turbo"
    })]
  })
}, {
  depth: 3,
  url: "#ci에서-turbo-run-사용하기",
  title: _jsxs(_Fragment, {
    children: ["CI에서 ", _jsx("code", {
      children: "turbo run"
    }), " 사용하기"]
  })
}, {
  depth: 2,
  url: "#문제-해결",
  title: _jsx(_Fragment, {
    children: "문제 해결"
  })
}, {
  depth: 3,
  url: "#캐시-적중으로-인한-빌드-손상",
  title: _jsx(_Fragment, {
    children: "캐시 적중으로 인한 빌드 손상"
  })
}, {
  depth: 3,
  url: "#잘못된-환경-변수를-사용한-배포",
  title: _jsx(_Fragment, {
    children: "잘못된 환경 변수를 사용한 배포"
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 Continuous Integration 파이프라인에서 수행해야 하는 빌드, 린트, 테스트 및 기타 모든 task를 가속화합니다. 병렬화와 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), "을 통해 Turborepo는 CI를 극적으로 빠르게 만듭니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["CI 벤더를 Remote Cache에 연결하고 task를 실행하는 방법의 예제는 ", _jsx(_components.a, {
        href: "/docs/guides/ci-vendors",
        children: "CI 가이드"
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "remote-caching-활성화하기",
      children: "Remote Caching 활성화하기"
    }), "\n", _jsx(_components.p, {
      children: "CI에 대해 Remote Caching을 활성화하려면 Turborepo가 Remote Cache에 액세스할 수 있도록 환경 변수를 설정합니다."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "환경 변수"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_TOKEN"
            })
          }), _jsx(_components.td, {
            children: "Remote Cache에 액세스하기 위한 Bearer 토큰"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "TURBO_TEAM"
            })
          }), _jsxs(_components.td, {
            children: ["리포지토리와 연결된 계정 이름. ", _jsx("a", {
              href: "https://vercel.com/docs/monorepos/remote-caching#vercel-remote-cache",
              rel: "noreferrer noopener",
              target: "_blank",
              children: "Vercel Remote Cache"
            }), "를 사용하는 경우 ", _jsx(_components.a, {
              href: "https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fsettings&title=Get+team+slug",
              children: "팀의 slug"
            }), "입니다."]
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "를 통해 task를 실행하면 CI가 캐시를 적중하여 파이프라인을 가속화할 수 있습니다."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Remote Cache 호스팅",
      children: [_jsxs(_components.p, {
        children: ["Vercel의 내장 CI/CD는 설정 없이 관리되는 Vercel Remote Cache에 자동으로 연결됩니다. 다른 CI 벤더를 Vercel Remote Cache에 연결하기 위한 토큰을 가져오려면 ", _jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching#use-remote-caching-from-external-ci/cd",
          children: "Vercel Remote Cache 문서"
        }), "를 참조하세요."]
      }), _jsxs(_components.p, {
        children: ["자체 호스팅 Remote Cache 옵션은 ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching#remote-cache-api",
          children: "Turborepo의 Remote Cache 문서"
        }), "를 참조하세요."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "ci에서-task-실행하기",
      children: "CI에서 task 실행하기"
    }), "\n", _jsxs(_components.p, {
      children: ["개발 및 CI 머신에 ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "를 전역으로 설치"]
      }), "하면 개발부터 배포까지 전체 리포지토리를 실행하는 데 하나의 멘탈 모델을 사용할 수 있습니다. ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 등록한 task는 CI에서 정확히 동일하게 작동합니다."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["task 설정 방법에 대한 자세한 내용은 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/configuring-tasks",
          children: "Task 구성하기"
        }), " 페이지를 참조하세요."]
      }), "\n", _jsxs(_components.li, {
        children: ["CI에서 task를 실행하는 예제는 ", _jsx(_components.a, {
          href: "/docs/guides/ci-vendors",
          children: "CI 가이드"
        }), "를 참조하세요."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "진입점-필터링하기",
      children: "진입점 필터링하기"
    }), "\n", _jsxs(_components.p, {
      children: ["로컬에서 ", _jsx(_components.code, {
        children: "turbo"
      }), "로 작업할 때와 정확히 동일하게 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " 플래그"]
      }), "를 사용하여 task를 필터링할 수 있습니다. 패키지, 디렉토리 및 Git 기록별 필터링이 모두 CI에서 지원됩니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "CI에서 Git 기록 사용하기",
      children: _jsx(_components.p, {
        children: "소스 제어 변경 사항을 사용한 필터링은 머신에서 기록을 사용할 수 있는 경우에만\n가능합니다. shallow clone을 사용하는 경우 기록을 사용할 수 없습니다."
      })
    }), "\n", _jsxs(_components.p, {
      children: ["또한 ", _jsxs(_components.a, {
        href: "#running-only-affected-tasks",
        children: [_jsx(_components.code, {
          children: "--affected"
        }), " 플래그"]
      }), "를 사용하여 변경 사항이 있는 패키지의 task만 실행할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "docker",
      children: "Docker"
    }), "\n", _jsxs(_components.p, {
      children: ["Docker는 많은 배포 파이프라인의 중요한 부분입니다. ", _jsxs(_components.a, {
        href: "/docs/reference/prune",
        children: ["Turborepo의 ", _jsx(_components.code, {
          children: "prune"
        }), " 하위 명령"]
      }), "은 이미지에서 불필요한 종속성과 코드를 제거하여 경량 이미지를 배포하는 데 도움이 됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Docker를 사용하여 Turborepo에서 배포하는 방법에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/guides/tools/docker",
        children: "전용 Docker 가이드"
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "task-및-기타-불필요한-작업-건너뛰기",
      children: "Task 및 기타 불필요한 작업 건너뛰기"
    }), "\n", _jsx(_components.h3, {
      id: "영향을-받은-task만-실행하기",
      children: "영향을 받은 task만 실행하기"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--affected"
      }), " 플래그를 사용하여 변경 사항이 있는 task만 실행할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "다음과 같은 상황에서 이 플래그를 사용하려고 할 것입니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "monorepo의 패키지 전체에서 많은 task를 실행하고 있으며 코드 변경 사항이 있는 패키지의 task만 실행하려는 경우."
      }), "\n", _jsxs(_components.li, {
        children: ["Remote Cache를 사용하지 ", _jsx(_components.em, {
          children: "않지만"
        }), " CI에서 가능한 한 적은 작업을 수행하려는 경우."]
      }), "\n", _jsxs(_components.li, {
        children: ["Remote Cache를 ", _jsx(_components.em, {
          children: "사용하고"
        }), " 있으며 대규모 리포지토리에 있는 경우. 캐시에서 복원될 task의 양을 최소화하면 네트워크를 통해 전송할 데이터가 줄어들어 캐시 복원이 더 빨라집니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["이미 ", _jsx(_components.a, {
          href: "/docs/reference/run#advanced-filtering-examples",
          children: "고급 필터링 기술"
        }), " 또는 ", _jsx(_components.a, {
          href: "/docs/reference/turbo-ignore",
          children: _jsx(_components.code, {
            children: "turbo-ignore"
          })
        }), "를 사용하여 ", _jsx(_components.code, {
          children: "--affected"
        }), "와 동일하거나 유사한 동작을 생성하고 있는 경우. 이 새 플래그를 사용하여 스크립팅을 단순화할 기회가 있을 것입니다.", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "--affected"
            }), "는 모든 task를 실행하는 것으로 폴백하기 때문에 맞춤형 필터링보다 shallow clone을 더 우아하게 처리할 수 있습니다."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.h4, {
      id: "github-actions에서---affected-사용하기",
      children: ["GitHub Actions에서 ", _jsx(_components.code, {
        children: "--affected"
      }), " 사용하기"]
    }), "\n", _jsxs(_components.p, {
      children: ["CI/CD 파이프라인은 ", _jsx(_components.code, {
        children: "--affected"
      }), "를 사용하기에 완벽한 곳입니다. ", _jsx(_components.code, {
        children: "--affected"
      }), "를 사용하면 Turborepo는 ", _jsx(_components.code, {
        children: "GITHUB_BASE_REF"
      }), "와 같이 GitHub에서 설정한 환경 변수를 검사하여 GitHub Actions에서 실행 중임을 자동으로 감지할 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "PR의 컨텍스트에서 이는 Turborepo가 PR의 기본 브랜치와 PR의 헤드 브랜치 간에 변경된 패키지를 결정할 수 있음을 의미합니다. 이를 통해 PR의 변경 사항에 영향을 받는 패키지에 대해서만 task를 실행할 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "GITHUB_BASE_REF"
      }), "는 ", _jsx(_components.code, {
        children: "pull_request"
      }), " 및 ", _jsx(_components.code, {
        children: "pull_request_target"
      }), " 이벤트에서 잘 작동하지만 일반 push 이벤트에서는 사용할 수 없습니다. 이러한 경우 ", _jsx(_components.code, {
        children: "GITHUB_EVENT_PATH"
      }), "를 사용하여 커밋과 비교할 기본 브랜치를 결정합니다. force push 및 추가 커밋이 없는 브랜치 푸시에서는 브랜치의 첫 번째 커밋의 부모와 비교합니다."]
    }), "\n", _jsxs(_components.h3, {
      id: "turbo-ignore-사용하기",
      children: [_jsx(_components.code, {
        children: "turbo-ignore"
      }), " 사용하기"]
    }), "\n", _jsxs(_components.p, {
      children: ["코드베이스와 CI가 성장함에 따라 더 빠르게 만드는 더 많은 방법을 찾기 시작할 수 있습니다. 캐시를 적중하는 것이 유용하지만 작업을 완전히 건너뛸 수도 있습니다. ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "를 사용하면 어쨌든 캐시 적중으로 끝날 종속성 설치와 같은 긴 컨테이너 준비 단계를 건너뛸 수 있습니다."]
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "리포지토리-체크아웃하기",
          children: "리포지토리 체크아웃하기"
        }), _jsx(_components.p, {
          children: "리포지토리를 복제하는 것으로 시작합니다. 사용할 복제 깊이에 대한 기록이 있는 복제가 비교에 필요합니다."
        }), _jsx(Callout, {
          type: "good-to-know",
          children: _jsxs(_components.p, {
            children: ["기본적으로 ", _jsx(_components.code, {
              children: "turbo-ignore"
            }), "는 부모 커밋을 사용합니다. 더 깊이를 사용자\n지정하려면 ", _jsx(_components.a, {
              href: "/docs/reference/turbo-ignore",
              children: "turbo-ignore 참조"
            }), "를 참조하세요."]
          })
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "패키지-및-task에-대해-turbo-ignore-실행하기",
          children: ["패키지 및 task에 대해 ", _jsx(_components.code, {
            children: "turbo-ignore"
          }), " 실행하기"]
        }), _jsxs(_components.p, {
          children: ["기본적으로 ", _jsx(_components.code, {
            children: "turbo-ignore"
          }), "는 현재 작업 디렉토리의 ", _jsx(_components.code, {
            children: "build"
          }), " task를 사용합니다."]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["다른 task의 변경 사항을 확인하려면 ", _jsx(_components.code, {
              children: "--task"
            }), " 플래그를 사용합니다."]
          }), "\n", _jsx(_components.li, {
            children: "특정 패키지 및 해당 종속성의 변경 사항을 확인하려면 패키지 이름을 인수로 추가합니다."
          }), "\n"]
        }), _jsxs(Tabs, {
          items: ["web#build (Named)", "web#build (Inferred)", "docs#test (--task flag)"],
          children: [_jsxs(Tab, {
            value: "web#build (Named)",
            children: [_jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "web"
              }), " 패키지를 인수로 추가하여 ", _jsx(_components.code, {
                children: "web"
              }), " 패키지 및 해당 종속성에 대한 ", _jsx(_components.code, {
                children: "build"
              }), " task의 변경 사항을 확인합니다:"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo-ignore"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " web"
                    })]
                  })
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "web#build (Inferred)",
            children: [_jsxs(_components.p, {
              children: [_jsx(_components.a, {
                href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
                children: "자동 패키지 범위 지정"
              }), "을 사용하여 ", _jsx(_components.code, {
                children: "web"
              }), " 패키지 및 해당 종속성에 대한 ", _jsx(_components.code, {
                children: "build"
              }), " task의 변경 사항을 확인합니다:"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "cd"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " apps/web"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo-ignore"
                    })]
                  })]
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "docs#test (--task flag)",
            children: [_jsxs(_components.p, {
              children: [_jsx(_components.a, {
                href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
                children: "자동 패키지 범위 지정"
              }), " 및 ", _jsx(_components.code, {
                children: "--task"
              }), " 플래그를 사용하여 ", _jsx(_components.code, {
                children: "docs"
              }), " 패키지 및 해당 종속성에 대한 ", _jsx(_components.code, {
                children: "test"
              }), " task의 변경 사항을 확인합니다:"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "cd"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " apps/docs"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npx"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo-ignore"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --task=test"
                    })]
                  })]
                })
              })
            })]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "결과-처리하기",
          children: "결과 처리하기"
        }), _jsxs(_components.p, {
          children: ["패키지 또는 해당 ", _jsx(_components.a, {
            href: "/docs/core-concepts/internal-packages",
            children: "내부 종속성"
          }), "에서 변경 사항이 감지되면 ", _jsx(_components.code, {
            children: "turbo"
          }), "는 ", _jsx(_components.code, {
            children: "1"
          }), " 상태 코드로 종료됩니다. 변경 사항이 감지되지 않으면 ", _jsx(_components.code, {
            children: "0"
          }), "으로 종료됩니다."]
        }), _jsxs(_components.p, {
          children: ["이 상태 코드를 사용하여 CI 파이프라인의 나머지 부분이 수행해야 할 작업을 선택할 수 있습니다. 예를 들어, ", _jsx(_components.code, {
            children: "1"
          }), " 종료 코드는 종속성을 설치하고 task를 실행하는 것으로 진행해야 함을 의미할 것입니다."]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["더 고급 사용 사례는 ", _jsxs(_components.a, {
        href: "/docs/reference/turbo-ignore",
        children: [_jsx(_components.code, {
          children: "turbo-ignore"
        }), " 참조"]
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "모범-사례",
      children: "모범 사례"
    }), "\n", _jsx(_components.h3, {
      id: "캐싱에-의존하기",
      children: "캐싱에 의존하기"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 캐싱 기능을 사용하면 최소한의 복잡성으로 빠른 CI 파이프라인을 생성할 수 있습니다. ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), " 및 ", _jsx(_components.code, {
        children: "--filter"
      }), " 플래그를 사용하여 빌드할 패키지를 대상으로 지정하면 Turborepo는 오버헤드가 거의 없이 대규모 monorepo에 대한 변경 감지를 처리합니다."]
    }), "\n", _jsx(_components.p, {
      children: "예를 들어, CI는 다음 두 명령을 실행하여 품질 검사를 빠르게 처리하고 대상 애플리케이션을 빌드할 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo run lint check-types test"
        }), ": 전체 리포지토리에 대한 품질 검사를 실행합니다. 변경되지 않은 패키지는 캐시를 적중합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo build --filter=web"
        }), ": ", _jsx(_components.code, {
          children: "turbo.json"
        }), "에 등록한 ", _jsx(_components.code, {
          children: "build"
        }), " task를 사용하여 ", _jsx(_components.code, {
          children: "web"
        }), " 패키지를 빌드합니다. ", _jsx(_components.code, {
          children: "web"
        }), " 패키지 또는 해당 종속성이 변경되지 않은 경우 빌드도 캐시를 적중합니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "코드베이스가 확장됨에 따라 CI를 최적화할 더 구체적인 기회를 찾을 수 있지만 캐싱에 의존하는 것이 시작하기에 좋은 곳입니다."
    }), "\n", _jsxs(_components.h3, {
      id: "ci에서-전역-turbo",
      children: ["CI에서 전역 ", _jsx(_components.code, {
        children: "turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["전역 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 사용하면 CI 워크플로우에서 편리하며 CI에 특정한 명령을 쉽게 실행하고 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
        children: "자동 Workspace 범위 지정"
      }), "을 활용할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["그러나 일부 경우에는 ", _jsx(_components.strong, {
        children: "패키지 관리자로 패키지를 설치하기 전에"
      }), " ", _jsx(_components.code, {
        children: "turbo"
      }), " 명령 또는 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 사용하는 스크립트를 실행할 수 있습니다. 이에 대한 한 가지 예는 ", _jsxs(_components.a, {
        href: "/docs/guides/tools/docker#example",
        children: [_jsx(_components.code, {
          children: "turbo prune"
        }), "을 사용하여 Docker 이미지를 생성"]
      }), "하는 것입니다. 이 상황에서 전역 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 해당 버전의 바이너리가 아직 설치되지 않았기 때문에 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 버전을 사용할 수 없습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이러한 이유로 주요 버전 내에서 중단 변경이 도입되지 않으므로 ", _jsxs(_components.strong, {
        children: ["CI에서 ", _jsx(_components.code, {
          children: "turbo"
        }), "의 전역 설치를 ", _jsx(_components.code, {
          children: "package.json"
        }), "의 주요 버전에 고정"]
      }), "하는 것을 권장합니다. 또한 정확한 버전을 고정하여 안정성을 추가로 선택할 수 있지만 패치 릴리스에서 버그 수정을 받기 위해 유지 관리 부담을 감수해야 합니다."]
    }), "\n", _jsxs(_components.h3, {
      id: "ci에서-turbo-run-사용하기",
      children: ["CI에서 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 사용하기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run"
      }), "은 Turborepo에서 작업할 때 가장 일반적으로 사용하는 명령이므로 편의를 위해 ", _jsx(_components.code, {
        children: "turbo"
      }), "로 별칭이 지정됩니다. 이는 로컬에서 작업하기에 좋지만 ", _jsx(_components.a, {
        href: "/docs/reference/prune",
        children: _jsx(_components.code, {
          children: "turbo prune"
        })
      }), " 및 ", _jsx(_components.a, {
        href: "/docs/reference/generate",
        children: _jsx(_components.code, {
          children: "turbo generate"
        })
      }), "와 같은 ", _jsx(_components.code, {
        children: "turbo"
      }), "에 대한 다른 하위 명령이 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["우리는 항상 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 개선하기 위해 노력하고 있으므로 향후 더 많은 하위 명령을 추가할 수 있습니다. 이러한 이유로 CI에서 ", _jsx(_components.code, {
        children: "turbo run"
      }), "을 사용하여 이름 충돌을 방지할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어, CI 파이프라인에 ", _jsx(_components.code, {
        children: "turbo deploy"
      }), " 명령이 있는 경우 ", _jsx(_components.code, {
        children: "turbo"
      }), " CLI에 직접 빌드된 잠재적인 ", _jsx(_components.code, {
        children: "deploy"
      }), " 하위 명령과 충돌할 수 있습니다. 이를 피하려면 CI 파이프라인에서 대신 ", _jsx(_components.code, {
        children: "turbo run deploy"
      }), "를 사용하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "문제-해결",
      children: "문제 해결"
    }), "\n", _jsx(_components.h3, {
      id: "캐시-적중으로-인한-빌드-손상",
      children: "캐시 적중으로 인한 빌드 손상"
    }), "\n", _jsxs(_components.p, {
      children: ["task가 ", _jsx(_components.strong, {
        children: "캐시를 미스할 때 통과하지만 캐시를 적중할 때 실패"
      }), "하는 경우, task에 대한 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: [_jsx(_components.code, {
          children: "outputs"
        }), " 키"]
      }), "를 올바르게 구성하지 않았을 가능성이 높습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "잘못된-환경-변수를-사용한-배포",
      children: "잘못된 환경 변수를 사용한 배포"
    }), "\n", _jsxs(_components.p, {
      children: ["task에 대해 ", _jsx(_components.code, {
        children: "env"
      }), " 또는 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 키를 정의하지 않은 경우 Turborepo는 해시를 생성할 때 이를 사용할 수 없습니다. 이는 다른 환경에 있음에도 불구하고 task가 캐시를 적중할 수 있음을 의미합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "env"
      }), " 및 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 키에 대한 구성을 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsxs(_components.p, {
      children: ["이제 Turborepo로 애플리케이션을 배포하는 데 필요한 모든 것이 있습니다. 특정 사용 사례에 대해 자세히 알아보려면 ", _jsx(_components.a, {
        href: "/docs/guides",
        children: "가이드 확인"
      }), " 또는 ", _jsx(_components.a, {
        href: "/docs/core-concepts",
        children: "핵심 개념 자세히 알아보기"
      }), "를 참조하세요."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
